import axios from "../api/axios";

export const getPrescriptionDetail = async (
  prescriptionId: string,
  token: string
) => {
  const response = await axios.get(`prescriptions/${prescriptionId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

export const checkPrescriptionOrder = async (
  prescriptionId: string,
  token: string
) => {
  const response = await axios.get(
    `prescriptions/check-order/${prescriptionId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.data;
};

export const getPrescriptionTracking = async (
  prescriptionId: string,
  token: string
) => {
  const response = await axios.get(
    `prescriptions/tracking-order/${prescriptionId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data.data;
};

export const sendPrescriptionEmail = async (
  prescriptionId: string,
  token: string
) => {
  const response = await axios.get(
    `prescriptions/send-email/${prescriptionId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};

export const cancelOnlinePrescription = async (
  prescriptionId: string,
  token: string
) => {
  const response = await axios.post(
    `prescription/${prescriptionId}/cancel-online`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return response.data;
};